import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Methods from './components/Methods';

import '@assets/css/dashboard.css';

import { crudActions } from '@sm/services/crudActions';
import { showAlert } from '@sm/store/alertSlice';
import { setFilters } from '@sm/store/dashboardSlice';

const Dashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    crudActions.get('v1/clients/lookups/dashboard')
      .then(response => {
        if (response) {
          response?.currencies.unshift({ label: 'All', value: '-1' });
          response?.payinMethods.unshift({ label: 'All', value: '-1' });
          response?.payoutMethods.unshift({ label: 'All', value: '-1' });
          dispatch(setFilters({
            filtersReady: true,
            currencies: response?.currencies,
            payinMethods: response?.payinMethods,
            payoutMethods: response?.payoutMethods,
            trafficTypes: response?.trafficTypes
          }));
        }
      })
      .catch(err => {
        dispatch(showAlert('danger', err?.message));
      });
  }, [dispatch]);

  return (
    <div className='col-12 module dashboard'>
      <Methods type='payin' />
      <Methods type='payout' />
    </div>
  );
};

export default Dashboard;
